import { render, staticRenderFns } from "./AdminContentWrapper.vue?vue&type=template&id=9c2df5e2&"
import script from "./AdminContentWrapper.vue?vue&type=script&lang=js&"
export * from "./AdminContentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AdminContentWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports